export default __webpack_public_path__ + "static/io_favicon-5e7ba632b5ba65cd02f6ff4a75d7e66c.ico";